import React from "react";
import Container from "../../utils/Container";
import Logo from "../../assets/logo/dhoorbin-logo-white.svg";
import Payment from "../../assets/banner/paywith_mobile_versionW.png";
import { Link } from "react-router";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";
const Footer = () => {
  return (
    <div className="mainFooter bg-[#091f44] text-white py-10 w-full ">
      <Container>
        <div className="grid sm:grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-20">
          <div className="space-y-3">
            <img
              className="w-[150px] lg:w-[220px]"
              src={Logo}
              alt="Dhoorbin.com"
            />
            {/* <p className="text-xs lg:text-sm text-start">
              <strong>Trade License: </strong>TRAD/DNCC/025421/2025
            </p> */}
            <p className="font-light text-xs lg:text-sm ">
              Dhoorbin.com is a platform for all travel enthusiats. Book your
              next holiday and avail exciting offers. Go Beyond!
            </p>
          </div>
          <div className="space-y-3">
            <p className="font-bold text-lg text-justify">We Accept</p>
            <img
              className="w-[180px] lg:w-[220px]"
              src={Payment}
              alt="Dhoorbin.com"
            />
          </div>
          <div className="space-y-3">
            <div>
              <p className="font-bold text-lg text-justify">Information</p>
            </div>
            <div className="flex flex-col gap-y-3">
              <Link to="/about-us">
                <p className="text-sm">About Us</p>
              </Link>
              <Link to="/privacy-policy">
                <p className="text-sm">Privacy and Policy</p>
              </Link>
              <Link to="/terms-and-conditions">
                <p className="text-sm">Terms and Condition</p>
              </Link>
              <Link to="#">
                <p className="text-sm">EMI Policy</p>
              </Link>
              <Link to="/refund-policy">
                <p className="text-sm">Refund Policy</p>
              </Link>
            </div>
          </div>
          <div className="space-y-3">
            <p className="font-bold text-lg text-start">Address</p>
            <p className="font-light text-sm text-start">
              <span className="font-bold">Head Office:</span> Red Sun Apartment,
              Ground floor, Kolatoli 4700 Cox's Bazar
            </p>
            <p className="font-light text-sm text-start">
              <span className="font-bold">Corporate Office:</span> 438/5,
              Senpara Parbata, Mirpur-10, Dhaka-1216
            </p>
            <p className="font-light text-sm text-start">
              <span className="font-bold">Email:</span> hello@dhoorbin.com{" "}
            </p>
            <p className="font-light text-sm text-start">
              <span className="font-bold">Call:</span> 09639203838{" "}
              <span className="font-thin text-xs">(Available 24/7)</span>
            </p>

            <div className="pt-5 flex justify-start items-center gap-x-2">
              <Link to="#" target="blank">
                <div className="w-8 h-8 flex justify-center items-center rounded-full bg-[#3463ff71]">
                  <FaFacebookF />
                </div>
              </Link>
              <Link to="#" target="blank">
                <div className="w-8 h-8 flex justify-center items-center rounded-full bg-[#3463ff71]">
                  <FaInstagram />
                </div>
              </Link>
              <Link to="#" target="blank">
                <div className="w-8 h-8 flex justify-center items-center rounded-full bg-[#3463ff71]">
                  <FaYoutube />
                </div>
              </Link>
              <Link to="#" target="blank">
                <div className="w-8 h-8 flex justify-center items-center rounded-full bg-[#3463ff71]">
                  <FaTiktok />
                </div>
              </Link>
              <Link to="#" target="blank">
                <div className="w-8 h-8 flex justify-center items-center rounded-full bg-[#3463ff71]">
                  <FaLinkedin />
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="py-8 lg:py-10">
          <hr />
        </div>
        <div>
          <p className="text-xs text-center lg:text-end">
            © {new Date().getFullYear()} All Rights Reserved | Dhoorbin.com
          </p>
        </div>
      </Container>
    </div>
  );
};

export default Footer;
